<div class="app-page" style="padding: 16px;">
  <mat-toolbar style="background-color: var(--mat-sys-background); color: var(--mat-sys-on-background);">
    <button mat-icon-button (click)="back()">
      <mat-icon>arrow_back_ios_new</mat-icon>
    </button>
    <span style="font-weight: 600;">SETTINGS</span>
  </mat-toolbar>

  <mat-nav-list style="margin-top: 12px;">
    <mat-divider></mat-divider>
    @if(isScoutAdmin()==true) {
      <a mat-list-item routerLink="/admin/tags" routerLinkActive="active" style="cursor: pointer;">
        <mat-icon matListItemIcon>sell</mat-icon>
        <span matListItemTitle>Tags</span>
        <span matListItemLine>Manage player tags and colors</span>
      </a>
    <!--   <a mat-list-item routerLink="/admin/app-colors" routerLinkActive="active" style="cursor: pointer;">
        <mat-icon matListItemIcon>palette</mat-icon>
        <span matListItemTitle>App Colors</span>
        <span matListItemLine>Configure app theme colors</span>
      </a> -->
    }

    @if(isUserAdmin()==true) {
      <a mat-list-item routerLink="/admin/scouts" routerLinkActive="active" style="cursor: pointer;">
        <mat-icon matListItemIcon>group</mat-icon>
        <span matListItemTitle>Scouts</span>
        <span matListItemLine>View and open scout user details</span>
      </a>
    }

   
    <mat-divider></mat-divider>
  </mat-nav-list>
</div>
